import Loading from "./Loading.tsx";
export default function Header() {
  return (
    <header className="w-full bg-white/20 backdrop-blur-md border border-white/30 shadow-lg p-6 flex items-center absolute top-0 right-0 h-5 fixed z-10">
      <ul className="flex w-full justify-between">
        <li>
          Noel John
        </li>
        <li>
          <a href="mailto:noeljohn.work@gmail.com">noeljohn.work@gmail.com</a>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/1RqiYbDaEoQDVgkvoszVobAovb2a5573-/view">
            Resume
          </a>
        </li>
      </ul>
    </header>
  );
}
